module.exports = __webpack_public_path__ + "static/media/tallinn-19.fda987f1.jpg";